const types = require('../types');
const bitOperations = require('../bitOperations');

function parse(hexString) {
    const bits = bitOperations.hexStringToBitString(hexString);
    //const headerbits = bits.substring(0, 11); //n/a
    const commissioningBits = bits.substring(12, 12 + 4);
    const itemBits = bits.substring(16, 16 + 48);
    const serialbits = bits.substring(64);
    const result = {
        hex: hexString.toUpperCase(),
        type: types.vueSerAuth.id,
        commisioningAuthority: bitOperations.bitStringToDecString(commissioningBits),
        itemNumber: bitOperations.bitStringToDecString(itemBits),
        serial: bitOperations.bitStringToDecString(serialbits)
    };
    result.toString = function () {
        return `urn:epc:tag:${result.type}:${result.commisioningAuthority}.${result.itemNumber}.${result.serial}`;
    };
    result.toTitle = () => hexString.toUpperCase();
    return result;
}

module.exports = {
    parse
};
